<template>
</template>

<script>
import { markRaw, toRaw } from 'vue'
import L from 'leaflet'
// 静的な require() は ESM のモジュールから呼ぶと { default } が返るため、import で受け取る
import markerAllUrl from '@/assets/img/marker-all.png'
import markerMossgreenUrl from '@/assets/img/marker-mossgreen.png'

export default {
  name: 'lmarker',
  data () {
    return {
      latlon: null,
      markerName: null,
      refreshMarkersTimer: null,
      markerRefreshRunId: 0
    }
  },
  created () {
    // if(this.env != null){
    //   console.log(this.env)
    //   this.fetchMarkers().then(() => {
    //     this.setMarker(this.sharedState.markersRaw).then(() => {
    //       this.renderMarker()
    //     })
    //   })
    // }
  },
  mounted () {
    this.scheduleRefreshMarkers()
  },
  beforeUnmount () {
    if (this.refreshMarkersTimer) {
      clearTimeout(this.refreshMarkersTimer)
    }
  },
  watch: {
    env: function (){
      this.scheduleRefreshMarkers()
    },
    markerLegends: function (){
      this.scheduleRefreshMarkers()
    }
  },
  methods: {
    scheduleRefreshMarkers (delay = 0) {
      if (this.refreshMarkersTimer) {
        clearTimeout(this.refreshMarkersTimer)
      }

      this.refreshMarkersTimer = setTimeout(() => {
        this.refreshMarkersTimer = null
        this.refreshMarkers()
      }, delay)
    },
    async refreshMarkers () {
      if (!this.env || !this.env.localAPI_markers || !this.sharedState.uid) {
        return
      }

      const runId = ++this.markerRefreshRunId
      await this.fetchMarkers()
      if (runId !== this.markerRefreshRunId) {
        return
      }

      this.clearRenderedMarkers()
      await this.setMarker(this.sharedState.markersRaw)
      if (runId !== this.markerRefreshRunId) {
        return
      }

      this.renderMarker()
    },
    clearRenderedMarkers () {
      const map = toRaw(this.sharedState.map)
      if (!map || !this.sharedState.markers) {
        return
      }

      for (const markersCategory in this.sharedState.markers) {
        for (const marker of this.sharedState.markers[markersCategory]) {
          const rawMarker = toRaw(marker)
          if (map.hasLayer(rawMarker)) {
            this.$store.commit('removeLayer', rawMarker)
          }
        }
      }
    },
    // マーカーデータをGetし，整形し，storeに格納する．
    async fetchMarkers () {
      await this.$store.dispatch('fetchMarkers', this.$route.query);
    },
    // マーカーをマップに立てる．
    addMarkers () {
      // this.$store.commit('addMarkers', this.sharedState.markers);
      for (const markersCategory in this.sharedState.markers) {
        // 同じカテゴリに関してループを回す．
        for (const marker of this.sharedState.markers[markersCategory]) {
          this.$store.commit('addLayer', marker)
        }
      }
    },
    openInfoWindow(event) {
      // InfoWindowをマップに表示
      this.$store.commit('chgInfoWindowVisible', true) // open InfoWindow
    },
    // 取得したmarkerデータからleaflet用のマーカーオブジェクトを作成し，連想配列に格納
    async setMarker (res) {
      // カテゴリに対応したアイコンオブジェクトを返す関数
      const icon = (category) => {
        const iconURLs = this.sharedState.markerIconURLs;
        const iconUrl = (category in iconURLs)
          ? require(`@/${iconURLs[category]}`)
          : markerAllUrl;
        return markRaw(L.icon({
          iconUrl: iconUrl,
          iconRetinaUrl: iconUrl,
          iconSize: [20, 30],
          iconAnchor: [10, 30],
          popupAnchor: [0, -30]
        }));
      };
      // ポップアップに表示するコンテンツ
      let markers = {};
      if (!!res) {
        const markerDataSet = res.data;
        const self = this;
        for (const mdata of markerDataSet) {
          const marker = markRaw(L.marker([mdata.lat, mdata.lng], { icon: icon(mdata.category) })
            .on('click', (event) => {
              const zoom = toRaw(this.sharedState.map).getZoom()
              this.$store.commit('moveMapCenter', {latlng: event.latlng, zoom: zoom})
              this.$store.commit('setSelectedMarker', {
                name: mdata.name,
                address: mdata.address,
                lat: mdata.lat,
                lon: mdata.lng,
                category: mdata.category
              })
              this.$store.commit('chgLoadingModalVisible', true)
              this.openInfoWindow(event)
              if (this.sharedState.circle != null) {
                this.$store.commit('removeLayer', this.sharedState.circle);
              }
              const circle = markRaw(L.circle([mdata.lat, mdata.lng], parseInt(this.circleRange)));
              this.$store.commit('setCircle', circle)
              this.$store.commit('addLayer', circle)
            }))
          marker["property"] = "marker"
          const category = mdata.category;
          // markersにcategoryのキーがない場合，空配列で初期化
          if (!(category in markers)) markers[category] = [];
          markers[category].push(marker);
        }
      }
      const defIcon = () => {
        const iconUrl = markerMossgreenUrl;
        return markRaw(L.icon({
          iconUrl: iconUrl,
          iconRetinaUrl: iconUrl,
          iconSize: [20, 30],
          iconAnchor: [10, 30],
          popupAnchor: [0, -30]
        }));
      }
      // const cityName = this.env.hash2cityTable[this.$route.query.city]
      // const defaultPlace = this.env.cityConfig[cityName].defaultPlace
      const cityName = this.env.cityName
      const defaultPlace = this.env.cityConfig.defaultPlace
      const marker = markRaw(L.marker([defaultPlace.position.lat, defaultPlace.position.lng], { icon: defIcon() })
        .on('click', (event) => {
          const zoom = toRaw(this.sharedState.map).getZoom()
          this.$store.commit('moveMapCenter', {latlng: event.latlng, zoom: zoom})
          this.$store.commit('setSelectedMarker', {
            name: defaultPlace.name,
            address: defaultPlace.address,
            lat: defaultPlace.position.lat,
            lon: defaultPlace.position.lng,
            category: defaultPlace.category
          })
          this.$store.commit('chgLoadingModalVisible', true)
          this.openInfoWindow(event)
          // クリック時にマーカーの下にサークルを描画
          if (this.sharedState.circle != null) {
            this.$store.commit('removeLayer', this.sharedState.circle);
          }
          const circle = markRaw(L.circle([defaultPlace.position.lat, defaultPlace.position.lng], parseInt(this.circleRange)));
          this.$store.commit('setCircle', circle)
          this.$store.commit('addLayer', circle)
      }))
      marker["property"] = "marker"
      markers[defaultPlace.category] = []
      markers[defaultPlace.category].push(marker)
      this.$store.commit('setMarkers', markers);
    },
    renderMarker () {
        for (const marker in this.sharedState.markers) {
          this.sharedState.markers[marker].forEach(element => {
            this.$store.commit('addLayer', element)
            this.$store.commit('displayStyleNone', this.sharedState.markerLayerRetval)
          });
        }
    },
  },
  computed: {
    sharedState () {
      return this.$store.state
    },
    heatType_d () {
      return this.$store.state.heatType.d
    },
    circleRange () {
      return this.$store.state.circleRange
    },
    year () {
      return this.$store.state.year
    },
    env () {
      return this.sharedState.config_from_api
    },
    markerLegends () {
      return this.sharedState.markerLegends
    },
  }
}
</script>

